import { gql } from "@apollo/client";

export const GET_COMPANY_LEADERBOARD = gql`
  query GetCompanyLeaderboard($companyId: String!, $metric: String!, $month: String) {
    getCompanyLeaderboard(companyId: $companyId, metric: $metric, month: $month) {
      metric
      month
      minMonth
      entries {
        rank
        userId
        name
        office
        count
        isCurrentUser
      }
      currentUser {
        rank
        userId
        name
        office
        count
        isCurrentUser
      }
    }
  }
`;
